module.exports = __webpack_public_path__ + "static/media/teltonika.34195761.svg";